export default __webpack_public_path__ + "static/pies-and-slices-2-fafca6547f2f020532b4dc83d357f3d7.svg";